<script lang="ts" setup>
import Logo from '@kidzonet/logo'
</script>

<template>
    <a
        class="support-page-toolbar-logo"
        href="/"
        aria-label="main page link"
    >
        <Logo
            class="support-page-toolbar-logo__logo"
            fill="#fff"
        />
    </a>
</template>

<style>
    .support-page-toolbar-logo {
        color: #fff !important;
        text-decoration: none;

        &__logo {
            block-size: 24px;
            margin-block-start: 8px;
            fill: white;

            path {
                fill: white;
            }
        }

        @media (max-width: 500px) {
            display: none;
        }
    }
</style>
